//API
export const FETCH_START = 'fetch_start';
export const FETCH_SUCCESS = 'fetch_success';
export const FETCH_ERROR = 'fetch_error';
export const SHOW_MESSAGE = 'show_message';
export const UPDATING_CONTENT = 'updating_content';
export const SHOW_ERROR_MESSAGE = 'show_error_message';

// CATEGORY-DASHBOARD
export const SET_CAT_LIST = 'set_cat_list';
export const SET_CAT_DATA = 'SET_CAT_DATA';

// SUBCATEGORY-DASHBOARD
export const SET_SUBCAT_LIST = 'set_subcat_list';
export const SET_SUBCAT_DATA = 'set_subcat_data';

// CATEGORY POSTS INFO
export const SET_CAT_POSTS_INFO = 'set_cat_posts_info';

// MODAL SETTING
export const SHOW_MODAL = 'show_modal';
export const SHOW_DELETE_MODAL = 'show_delete_modal';
